import { useCredentialingTranslation } from '../../../../ui/hooks';
import { showCustomDialog } from '@juvare/common-web-ui/DialogHelper';
import { Button, Typography } from '@mui/material';
import { format } from 'date-fns';
import React from 'react';
import { JasBoardStatusLabelIcon } from '../components/JasBoardStatusLabelIcon';
import { JasBoardVerificationHistoryTable } from '../components/JasBoardVerificationHistoryTable';
const dateTimeFmt = 'yyyy-MM-dd HH:mm:ss';
const dateFmt = 'yyyy-MM-dd';
export function useJasBoardsStatusColumns() {
    const { t } = useCredentialingTranslation();
    const handleViewHistory = ({ jasBoard }) => {
        showCustomDialog({
            maxWidth: 'md',
            onEscapeKeyDown: (close) => close(),
            content: (close) => React.createElement(JasBoardVerificationHistoryTable, { jasBoard: jasBoard, onClose: () => close(undefined) }),
        });
    };
    const columns = [
        {
            headerLabel: t('table.jasBoardStatusHistory.labels.service'),
            sortKey: 'name',
            cellFunction: ({ name }) => React.createElement(Typography, { variant: 'body2' }, name),
        },
        {
            headerLabel: t('table.jasBoardStatusHistory.labels.status'),
            cellFunction: ({ status }) => (status ? React.createElement(JasBoardStatusLabelIcon, { status: status }) : null),
        },
        {
            tableCellSx: {
                display: {
                    xs: 'none',
                    sm: 'table-cell',
                },
            },
            headerLabel: t('table.jasBoardStatusHistory.labels.lastUpdated'),
            cellFunction: ({ lastUpdatedAt }) => lastUpdatedAt ? React.createElement(Typography, null, format(new Date(lastUpdatedAt), dateFmt)) : null,
        },
        {
            tableCellSx: {
                display: {
                    xs: 'none',
                    sm: 'table-cell',
                },
            },
            headerLabel: t('table.jasBoardStatusHistory.labels.lastChecked'),
            cellFunction: ({ lastCheckedAt }) => lastCheckedAt ? React.createElement(Typography, null, format(new Date(lastCheckedAt), dateTimeFmt)) : null,
        },
        {
            tableCellSx: {
                display: {
                    xs: 'none',
                    sm: 'table-cell',
                },
            },
            headerLabel: t('table.jasBoardStatusHistory.labels.lastSuccess'),
            cellFunction: ({ lastSuccessAt }) => lastSuccessAt ? React.createElement(Typography, null, format(new Date(lastSuccessAt), dateTimeFmt)) : null,
        },
        {
            headerLabel: t('table.jasBoardStatusHistory.labels.history'),
            cellFunction: ({ id, name }) => (React.createElement(Button, { onClick: () => handleViewHistory({ jasBoard: { name, id } }) }, t('table.jasBoardStatusHistory.labels.viewHistory'))),
        },
    ];
    return { columns };
}
